module.exports = __webpack_public_path__ + "static/media/payments-selected.35321cea.svg";